module.exports = __webpack_public_path__ + "static/img/aqzs55.1b524b32.jpg";